import styled, { css } from 'styled-components';

export const StickyTrack = styled.div`
  height: 100%;
  position: relative;
`;

type StickyElementProps = {
  position: 'middle' | 'bottom' | 'top';
  headerHeight: number;
  topMargin: number;
  zIndex: number;
};
export const StickyElement = styled.div<StickyElementProps>`
  z-index: ${p => p.zIndex};

  ${props =>
    props.position === 'middle' &&
    css`
      position: fixed;
      top: ${props.headerHeight + props.topMargin}px;
    `}

  ${props =>
    props.position === 'bottom' &&
    css`
      position: absolute;
      bottom: 0;
    `}

  @supports (position: sticky) {
    position: sticky;
    top: ${props => props.headerHeight + props.topMargin}px;
  }
`;
